
import { Tbl_userEdit } from './tbl_userEdit';
import { Tbl_userList } from './tbl_userList';
import { Tbl_userShow } from './tbl_userShow';
import { Tbl_userCreate } from './tbl_userCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_userList,
    edit: Tbl_userEdit,
    show: Tbl_userShow,
    create: Tbl_userCreate,
    icon: MapIcon
};
            